module.exports = __webpack_public_path__ + "assets/img/1771589512665_.pic_hd.28d50500.jpg";